module.exports = __webpack_public_path__ + "images/3787f5c5db98cc18063745983b92607f.png";